var map = {
	"./fastqrgenerator.com/content-types/business": 49214,
	"./onlineqrcode.com/content-types/business": 69878,
	"./qrcreator.com/content-types/business": 92623,
	"./qrnow.com/content-types/business": 77905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93300;